<template>
	<div>
		<el-container >
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="网关编号" property="name">
									<el-input
										v-model="searchForm.name"
										placeholder="网关编号"
										clearable
										@keyup.enter.native="getGatewayList"
									>
									</el-input>
								</el-form-item>
							</span>

							<!-- <div class="search-box-button search-button search_box_button_right"> -->
								<el-button size="mini" type="primary" @click.native.prevent="getGatewayList">查 询</el-button>
								<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							<!-- </div> -->

						</el-form>
					</div>
					<hr class="search_border">
					<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools" style="display: flex;">
							<el-button type="primary" @click="dialogVisible = true">新增</el-button>
						</div>
					</div>

					<el-table
						ref="multipleTable"
						:data="tableData"
						:height="tableHeight"
						:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
						border
						stripe
					>
						<el-table-column
								type="index"
								width="80"
								align="center"
								label="序号">
						</el-table-column>
						<el-table-column
								prop="gatewayNo"
								label="网关编号"
								align="center"
								width="180"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="gatewayName"
								label="网关别名"
								align="center"
								width="180"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="gatewayType"
								align="center"
								label="网关类型"
								width="120">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.gatewayType === 1" type="success">MQTT网关</el-tag>
								<el-tag size="small" v-else-if="scope.row.gatewayType === 0" type="danger"></el-tag>
							</template>

						</el-table-column>

						<el-table-column
								prop="LocationName"
								align="center"
								label="安装位置"
								width="180"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="onlineFlag"
								label="联网状态"
								align="center"
								width="100">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.onlineFlag === 1" type="success">联网</el-tag>
								<el-tag size="small" v-else-if="scope.row.onlineFlag === 0" type="danger">脱网</el-tag>
							</template>

						</el-table-column>
						
						<el-table-column
								prop="onlineTime"
								label="联网时间"
								align="center"
								width="180"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="lastTime"
								label="脱网时间"
								align="center"
								width="180"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="statusFlag"
								align="center"
								label="有效状态"
								width="100">
							<template slot-scope="scope">
								<el-tag size="small" v-if="scope.row.statusFlag === 1" type="success">正常</el-tag>
								<el-tag size="small" v-else-if="scope.row.statusFlag === 0" type="danger">禁用</el-tag>
							</template>

						</el-table-column>

						<el-table-column
							prop="icon"
							label="操作"
							width="220"
							fixed="right"
						>
							<template slot-scope="scope">
								<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
								<el-divider direction="vertical"></el-divider>
								<template>
									<el-popconfirm title="确定删除该网关吗？" @confirm="delHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>
								<el-divider direction="vertical"></el-divider>
								<template>
									<el-popconfirm title="确定重启该网关吗？" @confirm="reloadHandle(scope.row.id)">
										<el-button type="text" slot="reference">重启</el-button>
									</el-popconfirm>
								</template>
							</template>
						</el-table-column>

					</el-table>

					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:page-sizes="[10, 20, 50, 100]"
							:current-page="current"
							:page-size="size"
							:total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-form-item label="网关编号" prop="gatewayNo" label-width="100px">
					<el-input v-model="editForm.gatewayNo" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="网关别名" prop="gatewayName" label-width="100px">
					<el-input v-model="editForm.gatewayName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="安装位置" prop="locationName" label-width="100px">
					<el-input v-model="editForm.locationName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="状态" prop="statusFlag" label-width="100px">
					<el-radio-group v-model="editForm.statusFlag">
						<el-radio :label=0>禁用</el-radio>
						<el-radio :label=1>正常</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: "Gateway",
		data() {
			return {
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},
				mediumDialogVisible: false,
				mediumForm: {},

				tableData: [],
				mediumData: [],

				selectedIdentityId:'',
				machineTypeList:[],
				interfaceList:[],

				editFormRules: {
					gatewayNo: [
						{required: true, message: '请输入网关编号', trigger: 'blur'}
					],
					gatewayName: [
						{required: true, message: '请输入网关别名', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'machineNum'
				},
				treeSelectLocationId: 0,
				selectedMachineInfo: '',
				bindMachineId: '',
				newMediumVal: '',
				newMediumType: '',
				newMediumEndTime: '',
				// permTreeData: []
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 630: 550
			}
		},
		created() {
			this.getGatewayList()

			// this.$axios.get('/iot/machine/list').then(res => {
			// 	this.permTreeData = res.data.data
			// })
		},
		methods: {
			resetSearchForm() {
				this.searchForm = {}
				this.getGatewayList()
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				// console.log("勾选")
				// console.log(val)
				this.multipleSelection = val;
				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.size = val
				this.getGatewayList()
			},
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.current = val
				this.getGatewayList()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			resetMediumForm() {
				this.mediumDialogVisible = false
				this.mediumForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			handleMediumFormClose() {
				this.resetForm('mediumForm')
			},
			locationSelectNodeClick(locationdata) {
				this.$set(this.editForm, "locationId", locationdata.id);
				this.$set(this.editForm, "locationFullName", locationdata.fullName);
				// console.log(deptdata);
			},
			locationTreeNodeClick(locationdata) {
				this.treeSelectLocationId = locationdata.id;
				this.getGatewayList();
			},

			getGatewayList() {
				const loading = this.$loading({
					text: '加载中...',
				});
				this.$axios.get("/iot/gateway/list", {
					params: {
						name: this.searchForm.name,
						locationId: this.treeSelectLocationId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					loading.close();
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// console.log(this.editForm);
						this.$axios.post('/iot/gateway/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.getGatewayList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/iot/gateway/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				// console.log(ids)

				this.$axios.post("/iot/gateway/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getGatewayList()
						}
					});
				})
			},
			reloadHandle(id) {
				this.$axios.post("/iot/gateway/reload", id).then(res => {
					this.$message({
						showClose: true,
						message: '下发重启任务成功',
						type: 'success',
						onClose:() => {
						}
					});
				})
			},
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 96%;
	}
	.btn {
		display: flex;
		justify-content: right;

		/* .el-button:first-child {
			margin-right: 30px;
		} */
	}
</style>